{
	"recoveryPassword": "Recuperación de contraseña"
}
